export default "__VITE_ASSET__Cq02NRYZ__"